import { styled } from 'styled-components';
import { Skeleton, tk } from '@sunwebgroup/ui-components';
import { Card } from '@/scopes/common/components/Card';
import { CardHeader, CardMain } from '@/scopes/products/pages/components/RecommendedAccos/AccoCard/AccoCard';

const CardSkeleton = styled(Card)`
  position: absolute;
  bottom: ${tk('spacing_md')};
  left: ${tk('spacing_md')};
  right: ${tk('spacing_md')};
  box-shadow: none;

  @media ${tk('mq_tablet')} {
    left: ${tk('spacing_lg')};
    bottom: ${tk('spacing_lg')};
    right: unset;
    width: 320px;
    flex-direction: column;
  }
`;

const ImageSkeleton = styled(Skeleton)`
  width: 145px;
  flex-shrink: 0;

  @media ${tk('mq_tablet')} {
    width: 100%;
    aspect-ratio: 3/2;
  }
`;

const SmallTextSkeleton = styled(Skeleton)<{ $width?: string }>`
  width: ${({ $width }) => $width || '100px'};
  height: ${tk('typography_body_sm_size')};
`;

const LargeTextSkeleton = styled(Skeleton)`
  width: 75%;
  height: ${tk('typography_heading_md_size')};

  &:last-of-type {
    width: 90%;
  }
`;

const CardFooterSkeletonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const CardFooterSkeleton = styled(Skeleton)`
  height: 48px;
  width: 108px;
  border-radius: ${tk('radius_rounded')};
`;

export function MapAccoCardLoading() {
  return (
    <CardSkeleton>
      <ImageSkeleton />
      <CardMain>
        <CardHeader>
          <SmallTextSkeleton />
          <LargeTextSkeleton />
          <LargeTextSkeleton />
          <SmallTextSkeleton $width="225px" />
        </CardHeader>
        <CardFooterSkeletonContainer>
          <CardFooterSkeleton />
        </CardFooterSkeletonContainer>
      </CardMain>
    </CardSkeleton>
  );
}
